import { Component, OnInit } from '@angular/core';
import { CommonService } from '../service/common.service';
import { Router } from '@angular/router';
import { User } from '../models/user';
import { Istanza } from '../models/istanza';
import { Ruolo } from '../models/ruolo';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-registrazione',
  templateUrl: './registrazione.component.html',
  styleUrls: ['./registrazione.component.css']
})
export class RegistrazioneComponent implements OnInit {
  user: User=new User();
  hide = true;
  selectedRole:string='';
  selectedValueIstanza:string;
  istanze: Istanza[];
  currentIstanza: Istanza;
  ruoli: Ruolo[];
  rc:number;
  usertoedit: boolean;
  IPAddress:string;
  Port:string;
  Protocol:string;
  //pwd:string='';
  //confermaPwd:string='';

  selectedFile: File;
  retrievedImage: any;
  base64Data: any;
  retrieveResonse: any;
  imageName: any;
  registerForm: FormGroup;
  submitted = false;
  imagehaschanged=false;

  public message =  sessionStorage.getItem('token');

  constructor(private httpClient: HttpClient, private commonService: CommonService,
    private router: Router, private formBuilder: FormBuilder) {
      if (environment.address.isLocal){
        this.IPAddress=environment.address.localIP;
        this.Port=environment.address.localPort;
        this.Protocol=environment.address.localProtocol;
      }else{
        this.IPAddress=environment.address.remoteIP;
        this.Port=environment.address.remotePort;
        this.Protocol=environment.address.remoteProtocol;
      }
        this.registerForm = this.formBuilder.group({
                Firstname: [''],
                Lastname: [''],         
                Istanza: [''],
                Codiceistanza: [0],
                Nomeistanza: [''],
                Email: ['', [Validators.required, Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
                Password: ['', [Validators.required, Validators.minLength(8)]],
                confermaPwd: ['', [Validators.required, Validators.minLength(8)]],
                Cellulare: [''],
                Liberatoria: [''],
                checkLiberatoria: [false],
    //            Language: [''],
    //            Birthdate: [''],
    //            Birthcity: [''],
    //            Nationality: [''],
    //            Birthprovince: [''],
    //            Firstname: [''],
    //            Lastname: [''],
    //            Fiscalcode: [''],
    //            City: [''],
    //            Province: [''],
    //            Residence: [''],
    //            Zipcode: [''],
    //            Phone: [''],
              Ruolo: ['']
            });

    }

  ngOnInit(): void {
    this.commonService.getAllIstanze().subscribe((res) => {
      this.istanze = res;       
//      if (this.registerForm===undefined){

          if (this.commonService.currentIstanza!=null){
            this.istanze.forEach(element => {
              if (this.commonService.currentIstanza.Codice === element.Codice){
                this.currentIstanza = element;
                this.registerForm.patchValue({
                  Istanza: element.Nome,
                  Codiceistanza: element.Codice,
                  Nomeistanza: element.Nome
                  
                });
              }
            });
            this.manageChangeIstanza();
          }
    });
  }
get f() { return this.registerForm.controls; }

manageChangeIstanza(){
  this.selectedValueIstanza = this.registerForm.get('Istanza')?.value;
  if (this.selectedValueIstanza==undefined){
    return;
  }
  this.istanze.forEach(element => {
    if (this.selectedValueIstanza === element.Nome){
      this.currentIstanza = element;
      this.commonService.currentIstanza=element;
      this.registerForm.patchValue({
        Codiceistanza: element.Codice,
        Nomeistanza: element.Nome
      });
      this.commonService.getRuoliByIstanza(element.Codice).subscribe((res) => {
        this.ruoli = res;
      });
    }
  });
}

save() {
        this.submitted = true;
        if (this.registerForm.invalid) {
            alert("Errore: verifica i campi indicati con *");
            return;
        }else{
            this.commonService.registrazione(this.registerForm.value).subscribe(data => {
              this.rc=Number(data); //ritorna l'id dell'utente se è stato creato con successo
      //        console.log("--->SaveUser"+this.rc.toString());
              if (this.rc>0){
                alert("Utente creato con successo: attendere che l'amministratore attivi l'account");
              }else if (this.rc===-1){
                alert("Errore creazione utente");
              }else if (this.rc===-2){
                alert("Lo Username è di un utente esistente");
              }
              this.router.navigate(['login']);
            });
        }
    //    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.registerForm.value))
    }

  updateLiberatoria(checked: boolean, index?: number) {
    if (checked){ 
      this.registerForm.patchValue({ Liberatoria: "YES" });
    } else {
      this.registerForm.patchValue({ Liberatoria: "NO" });  
    }
  }
  tec(){
    window.open('assets/tec.html', '_blank', 'width=500,height=400');
  }
  cancel(){
    this.commonService.selectedUser=null;
    this.router.navigate(['login']);
  }



}
